import {
  AfterViewInit,
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  inject,
} from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-base-component',
    templateUrl: './base-component.component.html',
    styleUrls: ['./base-component.component.scss'],
    standalone: false
})
export class BaseComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  layoutService = inject(LayoutService);
  router = inject(Router);
  route = inject(ActivatedRoute);
  toast = inject(MessageService);

  ngOnInit(): void {
    // Base lifecycle hook for inheriting components.
  }

  ngOnDestroy(): void {
    // Base lifecycle hook for inheriting components.
  }

  ngOnChanges(changes: SimpleChanges): void {
    void changes;
    // Base lifecycle hook for inheriting components.
  }

  ngAfterViewInit(): void {
    // Base lifecycle hook for inheriting components.
  }
}
